// extracted by mini-css-extract-plugin
module.exports = {"title":"a2c79c7e7d--title--mu6yT","info_item":"a2c79c7e7d--info_item--SNURe","info_title":"a2c79c7e7d--info_title--_IiMS"};